import React, { useEffect, useState } from 'react';
import ProcessIndicator from '../ProcessIndicator';
import { CompanyDetailsProgresses } from 'assets/helperdata/client/company-details-progress';
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-hot-toast';
import { FaSpinner } from 'react-icons/fa';
import { Skeleton } from '@mui/material';

import { useLanguage } from '../../../../contexts/LanguageContext';

// ✅ Clear
const SurveyDetails = () => {
	const clientUser = useSelector((state) => state.main.client);
	const history = useNavigate();
	const [isInProgress, setIsInProgress] = useState(false);
	const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
	const [isFormProcessing, setIsFormProcessing] = useState(false);
	const [data, setData] = useState({
		platform: '',
		jobTitle: '',
		employees: '',
		interests: [],
		specifications: [],
		isAgreed: false,
		isAcknowledged: false,
		id: clientUser?.data?.id
	});
	const [interests, setInterests] = useState([]);
	const [specifications, setSpecifications] = useState([]);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 768);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {

		api.getClientInterestList().then((res) => {
			setInterests(res.data);
		});
		api.getClientSpec().then((res) => {
			setSpecifications(res.data);
		});

	}, []);

	useEffect(() => {
		if (clientUser?.data?.id) {
			api.getClientInformationSurvey(clientUser?.data?.id).then((res) => {
				if (res?.data?.companySurvey) {
					setData({
						platform: res.data?.companySurvey?.platform_id,
						jobTitle: res.data?.companySurvey?.job_title,
						employees: res.data?.companySurvey?.employee_id,
						notes: res.data?.companySurvey?.platform_notes ?? '',
						isAgreed: res.data?.companyInfo?.is_agreed,
						isAcknowledged: res.data?.companyInfo?.is_acknowledged,
						id: clientUser?.data?.id
					});
				}
			});
		}
	}, [clientUser?.data?.id]);

	const moveToNext = () => {
		if (data?.isAcknowledged !== 1 || data?.isAgreed !== 1 || data?.interests?.length < 1 || data?.specifications?.length < 1) {
			toast.error('Please fill all fields');
			setIsInProgress(false);
			setIsFormProcessing(false)
			return;
		}
		setIsInProgress(false);
		setIsFormProcessing(true)
		api
			.completeClientRegistration(data.id, data)
			.then((res) => {
				setIsFormProcessing(false)
				toast.success('Registration completed.');
			})
			.catch((err) => {
				setIsFormProcessing(false)
				console.log(err);
			});
		history('../client/company-verified');
	};
	const moveToBack = () => {
		setIsInProgress(false);
		history('../client/company-bank-details');
	};

	const calculateCompletionPercentage = () => {
		let fields = [];
		fields = ['interests', 'specifications', 'isAgreed', 'isAcknowledged'];
		
		const filledFields = fields.filter((field) => {
			if (field === 'interests' || field === 'specifications') {
				return Array.isArray(data[field]) && data[field].length > 0;
			}
			return !!data[field];
		});
		return (filledFields.length / fields.length) * 100;
	};

	const { t } = useLanguage()

	const completionPercentage = calculateCompletionPercentage();
	return (
		<div className={`main-page-client ${isMobile ? 'padding-mobile-client' : ''}`} style={{ marginBottom: '60px' }}>
			<div className="actions-company-details-client">
				<ProcessIndicator
					isInProgress={isInProgress}
					processes={CompanyDetailsProgresses}
					currentIndex={5}
					completionPercentage={completionPercentage}
				/>
			</div>
			<div className="company-details-client-content">
				<div className="" style={{ justifyContent: 'space-between' }}>
					<table className="projectmix-table-vertical-client">
						<tbody>
							<tr>
								<td className="fw-600" colSpan={2} style={{ textAlign: 'left', fontSize: isMobile ? 16 : 14 }}>
									{t('company-survey-details.interest')}
								</td>
							</tr>
							<tr>
								<td>
									{
										interests?.length > 0 ? (
											<div className="row">
												{
													interests.map((interest, index) => {
														const isChecked = data.interests?.includes(interest.id);
														return (
															<div className="col-6" key={index}>
																<div
																	className={`checkbox-check-container ${isChecked ? ' checked' : ''}`}
																	onClick={() => {
																		const newInterests = isChecked
																			? (data.interests || []).filter((id) => id !== interest.id)
																			: [...(data.interests || []), interest.id];
																		setData({ ...data, interests: newInterests });
																	}}
																>

																	<input
																		type="checkbox"
																		id={`interest-${interest.id}`}
																		checked={data.interests?.includes(interest.id)}
																		className="pm-checkbox"
																		style={{ marginTop: '-7px' }}
																		onChange={(e) => {
																			const newInterests = e.target.checked
																				? [...(data.interests || []), interest.id]
																				: (data.interests || []).filter((id) => id !== interest.id);
																			setData({ ...data, interests: newInterests });
																		}}
																	/>
																	<span htmlFor={`interest-${interest.id}`}>{interest.name}</span>
																</div>
															</div>
														)
													})
												}
											</div>
										) : (
											<div className="row">
												{[...Array(4)].map((e, i) => (
													<div className="col-6" key={i} style={{	marginBottom: '10px' }}>
														<Skeleton variant="rounded" width={'100%'} height={54}></Skeleton>
													</div>
												))}
											</div>
										)
									}
								</td>
							</tr>
							<tr>
								<td className="fw-600" colSpan={2} style={{ textAlign: 'left', fontSize: isMobile ? 16 : 14 }}>
									{t('company-survey-details.specifications')}
								</td>
							</tr>
							<tr>
								<td>
									{
										specifications?.length > 0 ? (
											<div className="row">
												{
													specifications.map((specification, index) => {
														const isChecked = data.specifications?.includes(specification.id);
														return (
															<div className="col-6" key={index}>
																<div
																	className={`checkbox-check-container${isChecked ? ' checked' : ''}`}
																	onClick={() => {
																		const newSpecifications = isChecked
																			? (data.specifications || []).filter((id) => id !== specification.id)
																			: [...(data.specifications || []), specification.id];
																		setData({ ...data, specifications: newSpecifications });
																	}}
																>
																	<input
																		type="checkbox"
																		id={`specification-${specification.id}`}
																		checked={isChecked}
																		className="pm-checkbox"
																		style={{ marginTop: '-6px' }}
																		readOnly
																	/>
																	<span htmlFor={`specification-${specification.id}`}>{specification.name}</span>
																</div>
															</div>
														);
													})
												}
											</div>
										) : (
											<div className="row">
												{[...Array(14)].map((e, i) => (
													<div className="col-6" key={i} style={{	marginBottom: '10px' }}>
														<Skeleton variant="rounded" width={'100%'} height={54}></Skeleton>
													</div>
												))}
											</div>
										)
									}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div className="group-chk-trms-dtls">
					<input
						type="checkbox"
						id="terms-checkbox"
						className="pm-checkbox"
						checked={data.isAgreed === 1} // Ensure checkbox is checked if data.isAgreed is 1
						onClick={() => setData({ ...data, isAgreed: data.isAgreed === 1 ? 0 : 1 })} // Toggle between 0 and 1
					/>
					<label htmlFor="terms-checkbox">
						{t('company-survey-details.agree-1')}{' '}
						<a href="https://projectmix.ai/terms-of-use" target="_blank" rel="noopener noreferrer">
							{t('company-survey-details.agree-2')}
						</a>
						{t('company-survey-details.and')}
						<a href="https://projectmix.ai/terms-of-use" target="_blank" rel="noopener noreferrer">
							{t('company-survey-details.agree-3')}
						</a>{' '}
					</label>
				</div>
				<div className="group-chk-trms-dtls">
					<input
						type="checkbox"
						className="pm-checkbox"
						id="acknowledge-checkbox"
						checked={data.isAcknowledged === 1} // Ensure checkbox is checked if data.isAcknowledged is 1
						style={{ marginBottom: isMobile ? 20 : 0 }}
						onClick={() => setData({ ...data, isAcknowledged: data.isAcknowledged === 1 ? 0 : 1 })} // Toggle between 0 and 1
					/>
					<label htmlFor="acknowledge-checkbox">{t('company-survey-details.agree-4')}</label>
				</div>
			</div>
			<div className="action-company-dtls-adrs-btn" style={{ marginTop: 10 }}>
				<button
					className="btn btn-cmpny-dtls-action-back"
					onClick={() => {
						setIsInProgress(true);
						moveToBack();
					}}
				>
					<MdKeyboardArrowLeft /> {t('company-survey-details.back')}
				</button>

				<button
					className={`btn btn-cmpny-dtls-action ${isFormProcessing ? 'disabled' : ''}`}
					disabled={isFormProcessing}
					onClick={() => {
						if (isFormProcessing) return;
						setIsFormProcessing(true)
						setIsInProgress(true);
						moveToNext();
					}}
				>
					{
						isFormProcessing ? (
							<div><FaSpinner className='spinner' style={{ height: '18px' }} /> <span style={{ marginLeft: '-7px' }}>Please wait...</span></div>
						) : (
							<>
								{t('company-survey-details.next')} <MdKeyboardArrowRight />
							</>
						)
					}
				</button>
			</div>
		</div>
	);
};

export default SurveyDetails;
